export default __webpack_public_path__ + "static/Signika-Regular-40faea582b8adf0d07adfab2f00d4d9c.ttf";